import React from "react";

const CheckSuccess = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.29285 8.9591C1.29285 5.25481 4.29577 2.25189 8.00005 2.25189C11.7043 2.25189 14.7073 5.25481 14.7073 8.9591C14.7073 12.6634 11.7043 15.6663 8.00005 15.6663C4.29577 15.6663 1.29285 12.6634 1.29285 8.9591ZM11.5969 7.15049C11.7921 6.95523 11.7921 6.63865 11.5969 6.44338C11.4016 6.24812 11.085 6.24812 10.8897 6.44338L6.91897 10.4142L5.11036 8.60555C4.9151 8.41028 4.59852 8.41028 4.40326 8.60555C4.20799 8.80081 4.20799 9.11739 4.40326 9.31265L6.56542 11.4748C6.76068 11.6701 7.07726 11.6701 7.27253 11.4748L11.5969 7.15049Z"
        fill="#78B856"
      />
    </svg>
  );
};

export default CheckSuccess;
